import type { FriendVisitDetails } from '.';
import { Feature } from '../analytics';
import {
  ChatbotMessagePayload,
  generateReplicantChatbotPayload,
} from '../chatbot/messageTemplates';
import { State } from '../State';

export const getHadVisitorChatbotPayload = (args: {
  friendId: string;
  friendPet: FriendVisitDetails;
  visits: number;
  visited: number;
  isFriend: boolean;
  now: number;
  state: State;
}): ChatbotMessagePayload => ({
  ...generateReplicantChatbotPayload({
    feature: Feature.VISIT._,
    $subFeature: args.isFriend
      ? Feature.VISIT.FRIEND
      : Feature.VISIT.NON_FRIEND,
  }),
  friendID: args.friendId,
  friendPetID: args.friendPet?.currentEvolution?.species,
  friendPetStomach: args.friendPet?.attributes.stomach,
  friendPetLove: args.friendPet?.attributes.love,
  friendDirtiness: args.friendPet?.attributes.dirtiness,
  friendUrine: args.friendPet?.attributes.urine,
  friendStress: args.friendPet?.attributes.stress,
  friendToothAcidity: args.friendPet?.attributes.toothAcidity,
  friendAge: args.friendPet?.age,
  visits: args.visits,
  visited: args.visited,
  alternativeWebIABBucket: 'enabled_mini_app', // this is to force all the visit messages to be sent with miniapp url so less frictions for new users who only landed on miniapp check https://github.com/play-co/buruburu/pull/9796#discussion_r2650252733
});
